import styled from 'styled-components';
import { TextInput } from '@met/react-components';

const FormColumn = styled.div`
  width: 100%;
  margin: 0 auto;

  > * + * {
    margin-top: 10px;
  }
`;

const CardholderInput = styled(TextInput)`
  width: 100%;
  box-sizing: border-box;
  height: 48px;
  font-family: Segoe UI, sans-serif;
  border: 1px solid #CCCCCC;
  border-radius: 0;

  &:focus {
    border-color: #DB011C;
    outline: none;
  }
`;

const BillingCodeInput = styled(CardholderInput)``;

export {
  FormColumn,
  CardholderInput,
  BillingCodeInput,
};
